import { typeZonePropertyReducer } from "../reducer/TypeZonePropertyReducer";

export const reducer = typeZonePropertyReducer;